import { ModalType } from "../Types"
import { ModalAction } from "../../Reducers/Client/ModalReducer"
import { ModalViewName } from "../../Models/Client/Modal"
import { ContactUsMessageExtraDataModel } from "../../Models/External/FeedbackModel"

export const openModal = (
    modalType:
        | ModalViewName.keys
        | ModalViewName.billing
        | ModalViewName.askIfReviewJobOutput
) => {
    const action: ModalAction = {
        type: ModalType.openModalView,
        payload: {
            type: modalType
        }
    }

    return action
}

export const openAddMyRequestModal = (templateID: string): ModalAction => ({
    type: ModalType.openModalView,
    payload: {
        type: ModalViewName.addMyRequest,
        templateID
    }
})

export const openContactFormModal = (
    prefilledMessage: string | undefined,
    extraData: ContactUsMessageExtraDataModel
): ModalAction => ({
    type: ModalType.openModalView,
    payload: {
        type: ModalViewName.contactForm,
        prefilledMessage,
        extraData
    }
})

export const closeModal = (): ModalAction => ({
    type: ModalType.closeModalView
})
